export const dataList = [
  {
    date: "2023-07-10",
    userFee: 1.73,
    userFlow: 38327112.0,
    userThirdFee: 1.73,
  },
  {
    date: "2023-07-11",
    userFee: 1.29,
    userFlow: 29720464.0,
    userThirdFee: 1.29,
  },
  {
    date: "2023-07-12",
    userFee: 9.98,
    userFlow: 24839368.0,
    userThirdFee: 0.04,
  },
  {
    date: "2023-07-13",
    userFee: 1.62,
    userFlow: 35893305.0,
    userThirdFee: 1.62,
  },
  {
    date: "2023-07-14",
    userFee: 1.7,
    userFlow: 37773863.0,
    userThirdFee: 1.7,
  },
  {
    date: "2023-07-15",
    userFee: 0.98,
    userFlow: 21343336.0,
    userThirdFee: 0.98,
  },
  {
    date: "2023-07-16",
    userFee: 2.26,
    userFlow: 50216416.0,
    userThirdFee: 2.26,
  },
  {
    date: "2023-07-17",
    userFee: 4.15,
    userFlow: 91209760.0,
    userThirdFee: 4.15,
  },
  {
    date: "2023-07-18",
    userFee: 3.22,
    userFlow: 168216200.0,
    userThirdFee: 3.22,
  },
  {
    date: "2023-07-19",
    userFee: 4.97,
    userFlow: 101511572.0,
    userThirdFee: 4.97,
  },
  {
    date: "2023-07-20",
    userFee: 6.73,
    userFlow: 149498462.0,
    userThirdFee: 6.73,
  },
  {
    date: "2023-07-21",
    userFee: 12.55,
    userFlow: 170569204.0,
    userThirdFee: 12.55,
  },
  {
    date: "2023-07-22",
    userFee: 18.91,
    userFlow: 265302170.0,
    userThirdFee: 18.91,
  },
  {
    date: "2023-07-23",
    userFee: 21.94,
    userFlow: 303094896.0,
    userThirdFee: 21.94,
  },
  {
    date: "2023-07-24",
    userFee: 24.44,
    userFlow: 337697819.0,
    userThirdFee: 25.8,
  },
  {
    date: "2023-07-25",
    userFee: 25.1,
    userFlow: 396559986.0,
    userThirdFee: 25.1,
  },
  {
    date: "2023-07-26",
    userFee: 24.91,
    userFlow: 382456622.0,
    userThirdFee: 27.08,
  },
  {
    date: "2023-07-27",
    userFee: 25.86,
    userFlow: 421830990.0,
    userThirdFee: 27.57,
  },
  {
    date: "2023-07-28",
    userFee: 27.68,
    userFlow: 474687144.0,
    userThirdFee: 30.39,
  },
  {
    date: "2023-07-29",
    userFee: 30.34,
    userFlow: 484107279.0,
    userThirdFee: 34.86,
  },
  {
    date: "2023-07-30",
    userFee: 20.72,
    userFlow: 408901508.0,
    userThirdFee: 24.36,
  },
  {
    date: "2023-07-31",
    userFee: 31.41,
    userFlow: 523108495.0,
    userThirdFee: 37.63,
  },
  {
    date: "2023-08-01",
    userFee: 42.78,
    userFlow: 666427633.0,
    userThirdFee: 54.99,
  },
  {
    date: "2023-08-02",
    userFee: 45.5,
    userFlow: 739738299.0,
    userThirdFee: 59.07,
  },
  {
    date: "2023-08-03",
    userFee: 42.23,
    userFlow: 695801275.0,
    userThirdFee: 55.52,
  },
  {
    date: "2023-08-04",
    userFee: 46.65,
    userFlow: 722195707.0,
    userThirdFee: 63.86,
  },
  {
    date: "2023-08-05",
    userFee: 46.28,
    userFlow: 790321728.0,
    userThirdFee: 63.8,
  },
  {
    date: "2023-08-06",
    userFee: 56.51,
    userFlow: 863096199.0,
    userThirdFee: 77.24,
  },
  {
    date: "2023-08-07",
    userFee: 53.55,
    userFlow: 890283768.0,
    userThirdFee: 73.03,
  },
  {
    date: "2023-08-08",
    userFee: 51.97,
    userFlow: 869962923.0,
    userThirdFee: 72.19,
  },
];
